import { FailedFetchResponse } from '../../../helpers/errors';
import { useOnMount } from '../../../hooks';

/**
 * On mount check for a "loginError" parameter in the URL query object and pass it to the onError function if there is
 * an error.
 */
const useLoginError = (onError: (failedResponse: FailedFetchResponse) => void, query: object) => {
  useOnMount(() => {
    if (query.loginError) {
      onError({
        message: query.loginError,
      });
    }
  });
};

export default useLoginError;
